import { render, staticRenderFns } from "./MoreCardLogin.vue?vue&type=template&id=15b2517b&scoped=true&"
import script from "./MoreCardLogin.vue?vue&type=script&lang=js&"
export * from "./MoreCardLogin.vue?vue&type=script&lang=js&"
import style0 from "./MoreCardLogin.vue?vue&type=style&index=0&id=15b2517b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2517b",
  null
  
)

export default component.exports